import { jsx as _jsx } from "react/jsx-runtime";
import { SelectPayoutModal } from './select-payout-modal';
import { useBreakpoints } from '../../../../../infra/dls/hooks/use-get-breakpoints';
export var SelectPayoutModalContainer = function (_a) {
    var barberName = _a.barberName, isOpen = _a.isOpen, onClose = _a.onClose, selectedPayoutMethod = _a.selectedPayoutMethod, onSelectPayoutMethod = _a.onSelectPayoutMethod;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    return (_jsx(SelectPayoutModal, { barberName: barberName, isOpen: isOpen, onClose: onClose, selectedPayoutMethod: selectedPayoutMethod, onSelectPayoutMethod: onSelectPayoutMethod, isMobileOrSmaller: isMobileOrSmaller }));
};
